import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/img/exclamation.svg'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "boxTitle d-flex justify-content-between mb-3" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { width: "120" }
const _hoisted_5 = {
  width: "220",
  class: "text-end"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { colspan: "99" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_assenza_cliente = _resolveComponent("assenza-cliente")!
  const _component_generic = _resolveComponent("generic")!
  const _component_messaggio_in_prenotazione = _resolveComponent("messaggio-in-prenotazione")!
  const _component_prenotazione_ricevuta = _resolveComponent("prenotazione-ricevuta")!
  const _component_ticket_ricevuto = _resolveComponent("ticket-ricevuto")!
  const _component_nota_su_cliente = _resolveComponent("nota-su-cliente")!
  const _component_commento_su_cliente = _resolveComponent("commento-su-cliente")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Avvisi",
        text: "Avvisi"
      }),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setAllRead && _ctx.setAllRead(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Segna tutti come letti",
          text: "Segna tutti come letti"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_toggler, {
        modelValue: _ctx.showUnreadOnly,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showUnreadOnly) = $event)),
          _ctx.init
        ]
      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
      _createVNode(_component_localized_text, {
        class: "ms-1",
        localizedKey: "Mostra solo non letti",
        text: "Mostra solo non letti"
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped backendNotificationTable",
      itemsPerPage: _ctx.pagedVm.perPage,
      items: _ctx.tableResult.data,
      totalItemsCount: _ctx.tableResult.count,
      filter: _ctx.pagedVm,
      onSearch: _ctx.init,
      showClearFilters: false,
      showItemsPerPageSelector: false
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("td", { width: "80" }, null, -1)),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Dettaglio",
                text: "Dettaglio"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Azioni",
                text: "Azioni"
              })
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.BaseBackendNotification[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_8, [
                (!item.readOn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-link btn-sm",
                      onClick: ($event: any) => (_ctx.setRead(item))
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1)
                    ]), 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              (item.type == 'AssenzaCliente')
                ? (_openBlock(), _createBlock(_component_assenza_cliente, {
                    key: 0,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (item.type == 'Generic')
                ? (_openBlock(), _createBlock(_component_generic, {
                    key: 1,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (item.type == 'MessaggioInPrenotazione')
                ? (_openBlock(), _createBlock(_component_messaggio_in_prenotazione, {
                    key: 2,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (item.type == 'PrenotazioneRicevuta')
                ? (_openBlock(), _createBlock(_component_prenotazione_ricevuta, {
                    key: 3,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (item.type == 'TicketRicevuto')
                ? (_openBlock(), _createBlock(_component_ticket_ricevuto, {
                    key: 4,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (item.type == 'NotaSuCliente')
                ? (_openBlock(), _createBlock(_component_nota_su_cliente, {
                    key: 5,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (item.type == 'CommentoSuCliente')
                ? (_openBlock(), _createBlock(_component_commento_su_cliente, {
                    key: 6,
                    item: item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "totalItemsCount", "filter", "onSearch"])
  ]))
}